const setupProfile = {
  title: 'Setup',
  subTitle: 'your business',
  labels: {
    email: 'Email',
    category: 'Category',
  },
  placeholders: {
    email: 'Enter email',
    ArName: 'Enter arabic name',
    EnName: 'Enter english name',
    category: 'Choose category',
    uploadLogo: 'Logo',
    banner: 'Banner',
    enDescription:'Describe your business in English',
    arDescription:'Describe your business in Arabic',
  },
  actionBTN: 'Save',
};

export default setupProfile;
